import { HeadingWithUnderline } from '@components/ui/heading/HeadingWithUnderline'
import { ProgramThumbnailGroupItem } from '@type/buzzkuri/program-detail'
import { ProgramsSlideContent } from './Content'
import { useProgramsSlide } from './hook'
import { ProgramsSlideBtn } from './SlideBtn'

type Peops = {
  heading: string
  programThumbnailGroup: ProgramThumbnailGroupItem[]
}

const UNIT_IMG_WIDTH = 23.4 //vw
const UNIT_MARGIN_WIDTH = 1.6 //vw
const UNIT_WIDTH = UNIT_IMG_WIDTH + UNIT_MARGIN_WIDTH
const ELEMENTS_COUNT_PER_DISPLAY = 2
const translateX = UNIT_WIDTH * ELEMENTS_COUNT_PER_DISPLAY

export const ProgramsSlide = ({
  heading,
  programThumbnailGroup,
}: Peops): JSX.Element => {
  const { idx, slideAction } = useProgramsSlide({
    programThumbnailGroup,
    ...{ perElm: ELEMENTS_COUNT_PER_DISPLAY },
  })

  return (
    <div className="relative lg:mt-[5.4vw] w-[87.2vw] lg:w-[60vw]">
      <HeadingWithUnderline heading={heading} Tag="h2" />
      <ProgramsSlideContent {...{ programThumbnailGroup, idx, translateX }} />
      <ProgramsSlideBtn {...{ slideAction }} />
    </div>
  )
}
